import { SpinnerProps } from 'interface';
import { CSSProperties } from 'react';
import { createAnimation } from '../utils/animation';

const clip = createAnimation(
  'Spinner',
  '0% {transform: rotate(0deg) scale(1)} 50% {transform: rotate(180deg) scale(0.8)} 100% {transform: rotate(360deg) scale(1)}',
  'loader'
);

const Spinner = ({
  loading = true,
  colour = '#ffffff',
  speedMultiplier = 1,
  cssOverride = {},
  size = 30,
  ...etc
}: SpinnerProps): JSX.Element | null => {
  const style: CSSProperties = {
    background: 'transparent !important',
    width: size,
    height: size,
    borderRadius: '100%',
    border: '2px solid',
    borderTopColor: colour,
    borderBottomColor: 'transparent',
    borderLeftColor: colour,
    borderRightColor: colour,
    display: 'inline-block',
    animation: `${clip} ${0.75 / speedMultiplier}s 0s infinite linear`,
    animationFillMode: 'both',
    ...cssOverride,
  };

  if (!loading) {
    return null;
  }

  return (
    <span style={style} {...etc} data-testid="spinner-loader" role="status" />
  );
};

export default Spinner;
